/**
 * The grab strip on a heading's right edge of the wide grids (HP-V4, Pedro 2026-10-19): drag
 * it to widen or narrow the column. It sits inside the heading cell (which is sticky, so it
 * positions the strip), and stops the heading's own click (sort/filter) and drag (move).
 */
import { useRef } from 'react';

export function ColumnResizeHandle({ width, onResize }: { width: number; onResize: (w: number) => void }) {
  const start = useRef<{ x: number; w: number } | null>(null);
  const onMouseDown = (e: React.MouseEvent) => {
    e.preventDefault(); e.stopPropagation();
    start.current = { x: e.clientX, w: width };
    const move = (ev: MouseEvent) => { if (start.current) onResize(start.current.w + ev.clientX - start.current.x); };
    const up = () => {
      start.current = null;
      window.removeEventListener('mousemove', move); window.removeEventListener('mouseup', up);
      document.body.style.cursor = '';
    };
    window.addEventListener('mousemove', move); window.addEventListener('mouseup', up);
    document.body.style.cursor = 'col-resize';
  };
  return (
    <div role="separator" aria-orientation="vertical" aria-label="Drag to change the column width"
      title="Drag to change the column width"
      draggable={false} onDragStart={(e) => { e.preventDefault(); e.stopPropagation(); }}
      onMouseDown={onMouseDown} onClick={(e) => e.stopPropagation()}
      style={{ position: 'absolute', top: 0, right: -3, width: 7, height: '100%', cursor: 'col-resize', zIndex: 5 }} />
  );
}
